<template>
    <div class="page">
        <div class="main">
            <img src="../../assets/images/okback1.png" class="topimg" alt="">
            <div class="urlbtn" @click="tourl()"></div>
        </div>
        <!-- <div class="totle">
            <div class="maintitle">专委会审核中</div>
            <div class="maininner">长按扫码添加【ACEMD申请答疑群】及时获悉相关信息</div>
            <div class="qrcode">
                <img src="../../assets/images/okqrcode.jpg" class="okqrcode" alt="">
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    components: {
    },
    name: 'newok',
    data() {
        return {

        }
    },
    computed: {
    },
    created() {
        document.title = "加入ACMED";
    },
    beforeDestroy() {

    },
    methods: {
        tourl() {
            window.location.href = "https://member.cmea.org.cn/"
        },
    }
}
</script>

<style lang="scss" scoped>
.page {
    width: 100%;
    height: 100%;
    position: relative;
    // background: rgb(247, 249, 253);
    background: linear-gradient(to right, #b8daf1, #cfe6f5, #a9cfec, #839ac5, #84acd2, #85b3db, #a1c7e2);
}

.totle {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.maintitle {
    margin: auto;
    text-align: center;
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 1rem;
}

.okqrcode {
    display: block;
    margin: auto;
    width: 55%;
    margin-top: 1rem;
}

.maininner {
    width: 73%;
    margin: auto;
    font-size: 20px;
}

.topimg {
    width: 100%;
}

.main {
    position: relative;
}

.urlbtn {
    position: absolute;
    width: 59%;
    height: 1rem;
    left: 50%;
    top: 5.8rem;
    transform: translateX(-50%);
}
</style>